import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function OTPLoginButton({
  errorEmailPhone,
  setErrorEmailPhone,
  emailPhoneValue,
  setShowOTPForm,
}) {
  const { t } = useTranslation();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?[0-9]\d{9}$/;

  const handleSendOTP = async () => {
    if (errorEmailPhone) return

    if (!emailPhoneValue) {
      setErrorEmailPhone("invalid_email_or_phone")
      return
    }

    if (!emailRegex.test(emailPhoneValue) && !phoneRegex.test(emailPhoneValue)) {
      setErrorEmailPhone("invalid_email_or_phone")
      return
    }

    setShowOTPForm(true)
  };

  return <PrimaryButton text={t("login")} onClick={handleSendOTP} />
}
